export const LOGOUT_INITIATED_KEY = "logout_initiated";
export const LOGIN_REQUIRED_AFTER_LOGOUT_KEY = "login_required_after_logout";

const readSessionStorageValue = (key) => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const writeSessionStorageValue = (key, value) => {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // sessionStorage unavailable
  }
};

const removeSessionStorageValue = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // sessionStorage unavailable
  }
};

export const markLogoutInitiated = () => {
  writeSessionStorageValue(LOGOUT_INITIATED_KEY, "true");
};

export const clearLogoutInitiated = () => {
  removeSessionStorageValue(LOGOUT_INITIATED_KEY);
};

export const isLogoutInitiated = () => readSessionStorageValue(LOGOUT_INITIATED_KEY) === "true";

export const markLoginRequiredAfterLogout = () => {
  writeSessionStorageValue(LOGIN_REQUIRED_AFTER_LOGOUT_KEY, "true");
};

export const clearLoginRequiredAfterLogout = () => {
  removeSessionStorageValue(LOGIN_REQUIRED_AFTER_LOGOUT_KEY);
};

export const isLoginRequiredAfterLogout = () =>
  readSessionStorageValue(LOGIN_REQUIRED_AFTER_LOGOUT_KEY) === "true";
